const ExpiredLink = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      
      {/* 🔹 Top Header */}
      {/* <header className="w-full border-b bg-white">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-lg font-semibold text-gray-800">
            Shared Conversation
          </h1>
        </div>
      </header> */}

      {/* 🔹 Main Content */}
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md w-full text-center">
          
          {/* Icon */}
          {/* <div className="mx-auto mb-6 w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 text-xl">
            
          </div> */}

          {/* Title */}
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            This link has expired
          </h2>

          {/* Description */}
          <p className="text-gray-500 mb-6">
            The shared conversation you’re trying to access is no longer available. 
            It may have expired or been removed.
          </p>

          {/* Actions */}
          <div className="flex justify-center gap-3">

            <button
              onClick={() => (window.location.href = "/")}
              className="px-4 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-800"
            >
              Go Home
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ExpiredLink;